class ShopTheLook extends HTMLElement {
  constructor() {
    super();
    this.currentGender = 'womens';
    this.hasToggle = this.dataset.hasToggle === 'true';
    this.containers = this.querySelectorAll('.shop-look__products');
    this.container = this.querySelector('.shop-look__products[data-gender="womens"]');
    this.prevBtn = this.querySelector('.shop-look__nav--prev');
    this.nextBtn = this.querySelector('.shop-look__nav--next');
    this.toggleBtns = this.querySelectorAll('.shop-look__toggle-btn');

    if (this.container && this.prevBtn && this.nextBtn) {
      this.scrollAmount = 180 + 6; // card width + gap
      this.isDown = false;
      this.startX = null;
      this.scrollLeft = null;

      // Initialize toggle functionality
      if (this.hasToggle) {
        this.initToggle();
      }

      // Check if we need to center items
      this.checkItemCount();

      this.init();
    }
  }

  checkItemCount() {
    const itemCount = this.container.children.length;
    if (itemCount <= 2) {
      this.container.classList.add('center-items');
      this.prevBtn.style.display = 'none';
      this.nextBtn.style.display = 'none';
    } else {
      this.container.classList.remove('center-items');
      this.prevBtn.style.display = '';
      this.nextBtn.style.display = '';
      this.checkScrollable();
    }
  }

  initToggle() {
    this.toggleBtns.forEach((btn) => {
      btn.addEventListener('click', () => this.handleToggleClick(btn));
    });
  }

  handleToggleClick(clickedBtn) {
    const targetGender = clickedBtn.dataset.gender;

    if (targetGender === this.currentGender) return;

    // Update button states
    this.toggleBtns.forEach((btn) => btn.classList.remove('active'));
    clickedBtn.classList.add('active');

    // Hide current container
    this.container.style.display = 'none';
    this.container.classList.add('shop-look__products--hidden');

    // Show new container
    this.currentGender = targetGender;
    this.container = this.querySelector(
      `.shop-look__products[data-gender="${targetGender}"]`
    );
    this.container.style.display = '';
    this.container.classList.remove('shop-look__products--hidden');

    // Re-check item count and scrollable state
    this.checkItemCount();

    // Reset scroll position
    this.container.scrollLeft = 0;
    this.updateButtonVisibility();
  }

  init() {
    // Button click handlers
    this.prevBtn.addEventListener('click', () => this.handlePrevClick());
    this.nextBtn.addEventListener('click', () => this.handleNextClick());

    // Attach events to all containers (both mens and womens)
    this.containers.forEach((container) => {
      // Mouse events
      container.addEventListener('mousedown', (e) =>
        this.handleDragStart(e)
      );
      container.addEventListener('mouseleave', () => this.handleDragEnd());
      container.addEventListener('mouseup', () => this.handleDragEnd());
      container.addEventListener('mousemove', (e) => this.handleDragMove(e));

      // Touch events - disabled to allow native smooth scrolling on mobile
      // The custom drag is only needed for mouse/desktop interactions

      // Scroll event for button visibility
      container.addEventListener('scroll', () =>
        this.updateButtonVisibility()
      );
    });

    // Initial visibility check
    this.checkScrollable();
  }

  handlePrevClick() {
    this.container.scrollBy({
      left: -this.scrollAmount,
      behavior: 'smooth',
    });
  }

  handleNextClick() {
    this.container.scrollBy({
      left: this.scrollAmount,
      behavior: 'smooth',
    });
  }

  handleDragStart(e) {
    this.isDown = true;
    this.container.style.cursor = 'grabbing';
    this.startX = e.pageX - this.container.offsetLeft;
    this.scrollLeft = this.container.scrollLeft;
  }

  handleTouchStart(e) {
    this.isDown = true;
    this.startX = e.touches[0].pageX - this.container.offsetLeft;
    this.scrollLeft = this.container.scrollLeft;
  }

  handleDragEnd() {
    this.isDown = false;
    this.container.style.cursor = '';
  }

  handleDragMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.container.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.container.scrollLeft = this.scrollLeft - walk;
  }

  handleTouchMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.touches[0].pageX - this.container.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.container.scrollLeft = this.scrollLeft - walk;
  }

  updateButtonVisibility() {
    const isAtStart = this.container.scrollLeft <= 0;
    const isAtEnd =
      this.container.scrollLeft >=
      this.container.scrollWidth - this.container.clientWidth - 1;

    if (isAtStart) {
      this.prevBtn.style.opacity = '0';
      this.prevBtn.style.pointerEvents = 'none';
    } else {
      this.prevBtn.style.opacity = '1';
      this.prevBtn.style.pointerEvents = '';
    }

    if (isAtEnd) {
      this.nextBtn.style.opacity = '0';
      this.nextBtn.style.pointerEvents = 'none';
    } else {
      this.nextBtn.style.opacity = '1';
      this.nextBtn.style.pointerEvents = '';
    }
  }

  checkScrollable() {
    const isScrollable =
      this.container.scrollWidth > this.container.clientWidth;
    if (!isScrollable) {
      this.prevBtn.style.display = 'none';
      this.nextBtn.style.display = 'none';
    } else {
      this.updateButtonVisibility();
    }
  }
}

customElements.define('shop-look', ShopTheLook);
